import { Currency } from '@/core/currency/interfaces';

const RWF: Currency = {
    name: 'Rwandan Franc',
    demonym: 'Rwandan',
    majorSingle: 'Franc',
    majorPlural: 'Francs',
    codeNumeric: '646',
    symbol: 'FRw',
    symbolNative: 'R₣',
    minorSingle: 'Centime',
    minorPlural: 'Centimes',
    ISOdigits: 0,
    decimals: 0,
    numToBasic: 100,
    code: 'RWF',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default RWF;
